import { useCallback } from 'react';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';

export const useLogClickTooltip = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_TOOLTIP',
      analytics: {
        TYPE: goodsBasic?.delivery_type_info.delivery_type,
      },
    });
  }, [goodsBasic?.delivery_type_info.delivery_type, logGoodsAnalytics]);
};
